<template>
    <v-container
      class="fill-height py-0 bglayer"
      fluid
      :style="`background: url(${background})`"
    >
      <v-row
        align="center"
        justify="center"
      >
        <v-col
          cols="12"
          sm="8"
          md="4"
          class="pa-0"
        >
          <v-card class="elevation-0 login--card pa-5 mx-auto" color="rgba(0, 0, 0, 0)">
            <v-card-text class="login--fieldbg pb-0">
              <ValidationObserver ref="observer">
                <v-form class="mt-2 mb-2">
                  <v-img
                    class="mb-11 mx-auto"
                    max-height="150"
                    max-width="250"
                    :src="logo"
                  ></v-img>
                  <ValidationProvider v-slot="{ errors }" name="Email Address" rules="required|email">
                    <v-text-field
                      label="Email Address"
                      name="login"
                      type="text"
                      v-model="form.email"
                      light
                      outlined
                      :error-messages="errors"
                      required
                      class="mb-2"
                    ></v-text-field>
                  </ValidationProvider>
                  <ValidationProvider v-slot="{ errors }" name="Password" rules="required">
                    <v-text-field
                      id="password"
                      label="Password"
                      name="password"
                      type="password"
                      v-model="form.password"
                      light
                      outlined
                      :error-messages="errors"
                      required
                    ></v-text-field>
                  </ValidationProvider>
                  <v-checkbox
                    v-model="form.remeberme"
                    label="Remember Me"
                    light
                  ></v-checkbox>
                </v-form>
              </ValidationObserver>
            </v-card-text>
            <v-card-actions class="px-0 pt-0">
              <v-spacer></v-spacer>
              <v-btn x-large min-width="248" light color="primary" class="mb-4 mt-0" @click.prevent="submit" :loading="loading" tile depressed>Log In</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
</template>

<script>
    import { mapActions } from 'vuex'
    import { required, email } from 'vee-validate/dist/rules'
    import { extend, ValidationObserver, ValidationProvider, setInteractionMode } from 'vee-validate'
    import logo from "@/assets/logo.png"
    import background from "@/assets/background.jpg"

    setInteractionMode('eager')

    extend('required', {
      ...required,
      message: '{_field_} can not be empty',
    })

    extend('email', {
      ...email,
      message: 'Email must be valid',
    })

    export default {
        props: {
        source: String,
        },
        data: () => ({
            form: {
                email: '',
                password: '',
                remeberme: false
            },
            loading: false,
            logo: logo,
            background: background
        }),
        components: {
          ValidationProvider,
          ValidationObserver,
        },
        methods: {
            ...mapActions({
              signIn: 'auth/signIn',
              getData: 'data/getData'
            }),
            async submit() {              
              let valid = await this.$refs.observer.validate()

              if(valid) {
                this.loading = true
                this.signIn(this.form).then(() => {
                    this.getData()
                    this.$router.replace({
                      name: 'Property Listing'
                    })
                }).catch(() => {
                  this.loading = false
                  this.$store.commit('SET_SNACKTYPE', 'red')
                  this.$store.commit('SET_SNACK', 'Login Failed! Please try again.')
                })
              }
            },
        }
    }
</script>

<style lang="sass">   
main
  &.v-content
    &.Home 
      background: #df2027

.transitionBG 
  position: fixed
  top: 0
  left: 0
  height: 100%
  width: 100%
  background: #000
  z-index: 9999999999
  
.login--card
  max-width: 420px
  background: #ffffffb5!important
  border-radius: 3px

.v-toolbar__title
  &.display-1
    &.text-uppercase
      &.font-weight-black
        &.sub--title 
          &.login--title
            font-size: 36px!important
            line-height: 1em!important
            letter-spacing: 0!important
            font-family: Pyxel!important
            margin-bottom: 15px!important

.title--toolbar 
  .v-toolbar__content 
    padding-left: 0
    padding-right: 0

.container
  &.bglayer
    &:before
      content: ""
      position: absolute
      width: 100%
      height: 100%
      background: rgb(37 37 37 / 78%)
      left: 0
      top: 0

.v-text-field
  &>.v-input__control
    &>.v-input__slot 
      margin-bottom: 0

    &>.v-text-field__details
      margin-bottom: 8px!important
      padding: 10px 5px
</style>